import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';    
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';           
import { Rank } from '@ascschool/model/category/rank.model';
import { DegreeService } from '@ascschool/services/category/degree.service';
import { Degree } from '@ascschool/model/category/degree.model';
import { GroupService } from '@ascschool/services/user/group.service';
import { Group } from '@ascschool/model/user/group.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { Observable } from 'rxjs';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { SchoolLevelService } from '@ascschool/services/school/school-level.service';
import { TypeOfSchoolService } from '@ascschool/services/category/typeofschool.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { GroupSchoolService } from '@ascschool/services/user/group-schools.service';
import { map } from 'rxjs/operators';
import { ButtonType } from '@ascschool/interface/setting';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { CategoryModel } from '@ascschool/model/category/category-model.model';
import { ChangeDetectorRef } from '@angular/core';
import { Level } from '@ascschool/model/category/level.model';
import { Staff } from '@ascschool/model/user/staff.model';
import { BoardService } from '@ascschool/services/category/board.service';
import { PositionService } from '@ascschool/services/category/position.service';
import { StaffService } from '@ascschool/services/user/staff.service';
import { SystemUserService } from '@ascschool/services/user/system-user.service';

@Component({
  selector: 'app-them-nguoi-dung-he-thong',
  templateUrl: './them-nguoi-dung-he-thong.component.html',
  styleUrls: ['./them-nguoi-dung-he-thong.component.scss']
})
export class ThemNguoiDungHeThongComponent implements OnInit {
  @Input() dataTransmission: any;

  PassWordFormControl = new FormControl('');
  staff = new Staff();
  searchAdvanced: boolean = false;
  loading: boolean = false;
  firstRowOnPage: number = 0;
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize = this.pageSizeOptions[2];
  searchForm: FormGroup;
  checkedAll: boolean = false;
  listGroupSelected: number[] = [];
  staffList: any;
  Total: number = 0;
  commonFilter = new CommonFilter();
  getBoardACFn: (value: any) => Observable<any>;
  boardSubscription: any;
  boardControl = new FormControl();
  getPositionACFn: (value: any) => Observable<any>;
  positionSubscription: any;
  positionControl = new FormControl();
  getGroupACFn : (value: any) => Observable<any>;
  groupSubscription : any;
  groupControl = new FormControl();

  
  pageIndex: number = 1;  
  checked = false;
  indeterminate = false;
  listOfCurrentPageData: any[] = [];
  setOfCheckedId = new Set<number>(); 
  isEditMode = false; 
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup; 
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = []; 
  searchTerm: string = '';  
  width: number;
  numberControl: number;
  private elementPageHeaderTable: ElementRef; 
 
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation: number = 50;
  isCollapse = true; 
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    public sizePageService: SizePageService,
   public utilsService: UtilsService,
   private boardService: BoardService,
    private positionService: PositionService,
    private service: StaffService,
    private groupService : GroupService,
    private systemUserService: SystemUserService,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[2];
    this.loadList();
    this.loadBoard();
    this.loadPosition();
    this.loadGroup();
  }
  search() {
    this.commonFilter.PageIndex = 1;
    this.loadList();
  }
  loadBoard() {
    this.getBoardACFn = (value: any) => this.boardService.getBoardSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.boardName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.boardSubscription) this.boardSubscription = this.boardControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.commonFilter, 'BoardId', this.boardControl.value);
    });
  }
  changeBoard(control: FormControl) {
    this.boardControl = control;
  }

  loadPosition() {
    this.getPositionACFn = (value: any) => this.positionService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.positionName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.positionSubscription) this.positionSubscription = this.positionControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.commonFilter, 'PositionId', this.positionControl.value);
    });
  }
  changePosition(control: FormControl) {
    this.positionControl = control;
  }

  loadGroup() {
    this.getGroupACFn = (value: any) => this.groupService.GetSelectPagingCreateByGroup({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.groupName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.groupSubscription) this.groupSubscription = this.groupControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.commonFilter, 'GroupId', this.groupControl.value);
    });
  }
  changeGroup(control: FormControl) {
    if(control.value){ 
      this.groupControl = control;
    }
  }
  loadList() {
    this.loading = true;
    this.staffList = [];
    this.service.getAllStaffBySystemUser(this.commonFilter).subscribe(
      (response: any) => {
        const list = response.results ? response.results : [];
        this.Total = (response && response.rowCount) ? response.rowCount : 0;
        this.firstRowOnPage = (response && response.firstRowOnPage) ? response.firstRowOnPage : 0;
        this.staffList = (list) ? list : [];
        this.loading = false;
      },
      (err: any) => {
        this.staffList = [];
        this.loading = false;
      }
    );

  }

  chooseSchool() {

    if(this.groupControl.value && this.groupControl.value != null && this.commonFilter.PassWord && this.commonFilter.PassWord != ''){ 
      this.setOfCheckedId.forEach(item => {
        this.listGroupSelected.push(item);
      });
      if (this.listGroupSelected.length > 0) {
        const passwordhash = this.utilsService.md5Encode(this.commonFilter.PassWord)
        this.systemUserService.addMultiple({groupId: this.groupControl.value.id, listStaffId: this.listGroupSelected,Password:passwordhash.toUpperCase()}).subscribe((res) => {
          if (res.statusCode == 0) {
            this.utilsService.notifyResponse(res);
            this.close();
          } else {
            this.utilsService.notifyResponse(res);
          }
        })
      } else {
        this.msg.warning('Vui lòng chọn nhân sự');
      }
    }else{
      this.msg.warning('Vui lòng chọn nhóm quyền và mật khẩu mặc định');
    }
    this.PassWordFormControl.markAsTouched();
    this.groupControl.markAsTouched();
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.loadList();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.loadList();
  }

  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse);
    // keyboard 
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value != 'string') return control.value.id;
    return '';
  }
   
  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.id, value));
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: any[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
}
